import Vue from 'vue'
import Vuex from 'vuex'

import service from './Service.module'
import searchFilters from './SearchFilters.module'
import organization from './Organization.module'
import location from './Location.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    service,
    searchFilters,
    organization,
    location,
  },
})
